import React, { Component } from 'react'
import TopArrowSvg from '../icons/TopArrowSvg'
import MenuIconSvg from '../icons/MenuIconSvg';
import { connect } from 'react-redux';

export class WindowTop0 extends Component {
    scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
    render() {
        const { contentData } = this.props;
        return (
            <button onClick={this.scrollToTop} className='fixed bottom-[20px] left-[20px] z-[989] p-[20px_12px] w-[64px] h-[64px] bg-[#666666] rounded-[50%] hidden max-[1010px]:block font-[600] text-[#fff] text-[16px]' dangerouslySetInnerHTML={{ __html: contentData?.nav_menu }} >

            </button>
        )
    }
}


const mapStateToProps = (state) => ({
    contentData: state.Data.contentData,
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(WindowTop0)